// Get reserve data response
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue8, FctValue40, FctValue128 } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { LENDING_POOL_ADDRESSES } from '../constants';
export var GetReserveData = createPlugin({
    protocol: 'RADIANTV2',
    type: 'GETTER',
    method: 'getReserveData',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'radiant_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getRadiantV2Tokens({ chainId: chainId }) }),
                },
            },
            output: {
                configuration: new FctValue({ innerIndex: 0 }),
                liquidityIndex: new FctValue128({ innerIndex: 1 }),
                variableBorrowIndex: new FctValue128({ innerIndex: 2 }),
                currentLiquidityRate: new FctValue128({ innerIndex: 3 }),
                currentVariableBorrowRate: new FctValue128({ innerIndex: 4 }),
                currentStableBorrowRate: new FctValue128({ innerIndex: 5 }),
                lastUpdateTimestamp: new FctValue40({ innerIndex: 6 }),
                aTokenAddress: new FctAddress({ innerIndex: 7 }),
                stableDebtTokenAddress: new FctAddress({ innerIndex: 8 }),
                variableDebtTokenAddress: new FctAddress({ innerIndex: 9 }),
                interestRateStrategyAddress: new FctAddress({ innerIndex: 10 }),
                id: new FctValue8({ innerIndex: 11 }),
            },
        });
    },
});
